import React, { useContext } from "react";
import Button from "~/components/parts/Button";
import { SubscriptionDispatchContext } from "../..";

const Start = () => {
  const dispatch = useContext(SubscriptionDispatchContext);

  return (
    <Button
      className="max-w-[350px] bg-blue-500 p-2 text-sm text-white shadow-sm hover:bg-blue-500 disabled:bg-blue-200 disabled:text-white disabled:shadow-none"
      onClick={() => dispatch({ type: "start_form" })}
    >
      Start application
    </Button>
  );
};

export default Start;
